import type { ReactNode } from 'react';
import { useCallback, useMemo, useState } from 'react';

import {
  ChunkUploadContext,
  type ChunkUploadFunction,
} from './ChunkUploadContext';

interface ChunkUploadProviderProps {
  children: ReactNode;
}

export const ChunkUploadProvider = ({ children }: ChunkUploadProviderProps) => {
  const [queueChunkUpload, setQueueChunkUploadState] =
    useState<ChunkUploadFunction | null>(null);

  // Wrap the setter to handle functions correctly (React useState treats functions as updaters)
  const setQueueChunkUpload = useCallback((fn: ChunkUploadFunction | null) => {
    setQueueChunkUploadState(() => fn);
  }, []);

  const value = useMemo(
    () => ({
      queueChunkUpload,
      setQueueChunkUpload,
    }),
    [queueChunkUpload, setQueueChunkUpload],
  );

  return (
    <ChunkUploadContext.Provider value={value}>
      {children}
    </ChunkUploadContext.Provider>
  );
};
